import { css } from 'emotion'

export const textAlignLeft = css`
  text-align: left;
`
